import { useTranslation } from 'react-i18next';

interface DrawProgressBadgeProps {
  count: number;
}

export function DrawProgressBadge({ count }: DrawProgressBadgeProps) {
  const { t } = useTranslation('map');

  return (
    <div
      className="absolute bottom-6 left-1/2 z-40 -translate-x-1/2 rounded-full border border-primary/30 bg-primary/90 px-3 py-1 text-[11px] font-semibold text-primary-foreground shadow-lg"
      data-testid="draw-progress-badge"
      aria-live="polite"
    >
      {t('areaSelection.drawBadge', { count })}
    </div>
  );
}
